import styles from './IframeSingleEvent.module.scss';
import React from "react";
import { PushkinBlockForEntity } from "@kursk/components/ui/PushkinBlockForEntity/PushkinBlockForEntity";
import { TimetableList } from '@kursk/components/ui/TimetableBlock/TimetableList/TimeTableList';
import { HeaderBlock } from './HeaderBlock/HeaderBlock';
import { IframeCloseIcon } from '@kursk/components/ui/icons';
import Link from 'next/link';
import { IEvent } from '@common/redux/types/event';

type TProps = {
  event: IEvent;
}

export const IframeSingleEvent = ({ event }: TProps) => {
  const isPushkin = event?.source?.meta?.pushkin;
  if (!event) {
    return <></>;
  }

  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <Link href={`/iframe/organizations/${event.organization.sysName}`}>
          <a className={styles.backBtn}>
            <IframeCloseIcon />
            <div>Назад</div>
          </a>
        </Link>
        <section className={styles.hero}>
          <HeaderBlock entity={event} />
        </section>
        <section className={styles.schedule}>
          {isPushkin && <PushkinBlockForEntity isIframe />}
          {(event?.actualSeances?.all?.length > 0) && (
            <TimetableList data={event?.actualSeances.all} event={event} withDateFilter forRef={null} isIframe />
          )}
        </section>
      </div>
    </div>
  )
}
